import * as ContextMenu from '@studio/design-system/context-menu';
import { getMenuItemHandler } from '@studio/design-system/menu';
import { shortCircuit } from '@studio/react-utils/event';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import type { MenuProps } from './types.js';

/** `<Menu>` component. */
export const Menu = ({ handler, ...props }: MenuProps): ReactElement => {
  const handleSelect = useLatestFn((event: Event) => {
    getMenuItemHandler(handler, event)?.();
  });

  return (
    <ContextMenu.Content onCloseAutoFocus={shortCircuit} {...props}>
      {/* TODO: Add back in when we have a way to update the preset position */}
      {/* <ContextMenu.Item
        action='refresh'
        icon='preset-position'
        label='Update with current position'
        onSelect={handleSelect}
      /> */}

      <ContextMenu.Item action='rename' icon='edit' label='Rename preset' onSelect={handleSelect} />

      <ContextMenu.Item
        action='remove'
        icon='trash'
        label='Delete preset'
        onSelect={handleSelect}
      />
    </ContextMenu.Content>
  );
};
